/**
 * class Fr
 *
 * In dieser Klasse sind alle Übersetzungestexte für Deutsch hinterlegt.
 */
class Fr {
  constructor () {
    this.label_Umfang = 'Nombre de pages'
    this.label_seitig = 'pages'
    this.label_Format = 'Format'
    this.label_Format_Anhefter = 'Format (pour 1 page ou pour les agrafes pliées)'
    this.label_Ausrichtung = 'Orientation de la page'
    this.label_Hochformat = 'Portrait/Format long'
    this.label_Querformat = 'Paysage/Format oblong'
    this.label_Papier = 'Papier'
    this.label_ungestrichen = 'non couché'
    this.label_gestrichen = 'couché'
    this.label_Auflage = 'Tirage'
    this.label_Pages = 'Pages'
    this.label_Seitenaufdruck = 'Impression des pages'
    this.label_Einseitig = 'Recto'
    this.label_Doppelseitig = 'Recto/Verso'
    this.label_colorBackSide = 'Couleurs au verso'
    this.help_colorFrontBack = 'Le recto est toujours imprimé en quadrichromie. Pour le verso, il est possible de choisir entre la quadrichromie et le noir/blanc.'
    this.label_blackWhite = 'Noir/Blanc'
    this.label_color = 'En quadrichromie'
    this.label_calculate = 'Calculer...'
    this.label_error = 'Erreur de calcul'
    this.label_fold = 'Type de pliage'
    this.label_fold_f06_1 = 'Pli roulé'
    this.label_fold_f06_5 = 'Pli zickzack ou Leporello'
    this.label_c2c_certificate = 'C2C certificat'
    this.label_co2_weight = 'Émissions de CO2'
    this.label_qty = 'quantité'
    this.label_height = 'Hauteur (mm)'
    this.label_width = 'Largeur (mm)'

  }
}

export default Fr
